import HtmlElement from '../../../Elements/HtmlElement';

/**
 * Slider
 */
export default class Slider extends HtmlElement {
  constructor($element) {
    super($element);
    this.options = {};
  }

  initialize(options) {
    let _self = this;
    let mergedOptions = $.extend(true, options, this.$element.data('options'));

    if (mergedOptions['loop'] && this.$element.find('> *').length < 2) {
      mergedOptions['loop'] = false;
    }

    if (mergedOptions['nav']) {
      mergedOptions['navText'] = [
        '<i class="fas fa-angle-left"></i>',
        '<i class="fas fa-angle-right"></i>'
      ];
    }

    this.$element.on('initialized.owl.carousel', function () {
      _self.$element.css('opacity', 1);
    });

    this.$element.owlCarousel(mergedOptions);
  }
}
